<ng-container *ngIf="!isLoading">
  <div class="modal-body">
    <tabset>
      <tab
        (selectTab)="tabChange('new')"
        heading="{{ 'navigations.model.create' | translate }}"
      >
        <form [formGroup]="form">
          <div class="form-row">
            <div class="form-group col-12">
              <label
                [class.font-weight-bold]="form.get('name')?.dirty"
                for="name"
              >
                {{ "headers.fastpm.pm_model.model" | translate }}
                <span class="text-danger">*</span>
              </label>
              <input
                [ngClass]="{
                  'is-invalid': isSubmitted && form.get('name')?.invalid
                }"
                class="form-control form-control-sm"
                formControlName="name"
                id="name"
                type="text"
              />
            </div>
          </div>
          <div class="form-row" *ngIf="mode !== 'model'">
            <div class="form-group col-12">
              <label for="modelImages">
                {{ "headers.fastpm.pm_model.images" | translate }}
              </label>

              <app-core-image-slider
                #imageSlider
                *ngIf="mode === 'single' && (!imagesLoaded || hasExistingImages)"
                [entityType]="'fastpm_model'"
                [entityId]="targetIds[0]"
                [editable]="true"
                (imagesChange)="onSliderImagesChange($event)"
              ></app-core-image-slider>

              <ng-container *ngIf="imagesLoaded">
                <ng-container *ngIf="!hasExistingImages">
                  <app-core-image-upload
                    [multiple]="true"
                    [showSaveHint]="true"
                    (imagesUploaded)="onFormImagesUploaded($event)"
                  ></app-core-image-upload>
                </ng-container>

                <ng-container *ngIf="hasExistingImages">
                  <div class="text-center mt-2">
                    <button
                      type="button"
                      class="btn btn-sm btn-outline-primary"
                      (click)="openImageUploadModal()"
                    >
                      <i class="la la-upload"></i>
                      {{ "core_image_upload.add_images" | translate }}
                    </button>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </form>

        <!-- Image upload body template for the generic modal -->
        <ng-template #imageUploadBody>
          <app-core-image-upload
            #modalUploadComp
            [multiple]="true"
            (imagesUploaded)="onModalImagesUploaded($event)"
          ></app-core-image-upload>
        </ng-template>
      </tab>
      <tab
        (selectTab)="tabChange('model')"
        heading="{{ 'navigations.model.from' | translate }}"
        style="height: 450px"
      >
        <div class="d-flex flex-column h-100 w-100">
          <div class="d-flex align-items-center my-2">
            <div class="mr-2">
              <button
                (click)="modelsLoadItems(this.currentSite)"
                [ngClass]="{
                  'btn-success': modelsIsLoading,
                  'btn-light': !modelsIsLoading
                }"
                class="btn btn-sm"
              >
                <i
                  [ngClass]="{ 'la-spin': modelsIsLoading }"
                  class="la la-refresh"
                ></i>
              </button>
            </div>
            <div class="mr-2">
              <button
                (click)="modelsGrid?.expandAll()"
                [disabled]="modelsIsLoading"
                class="btn btn-light btn-sm"
              >
                <i class="la la-expand-arrows-alt"></i>
              </button>
            </div>
            <div class="mr-2">
              <button
                (click)="modelsGrid?.collapseAll()"
                [disabled]="modelsIsLoading"
                class="btn btn-light btn-sm"
              >
                <i class="la la-compress-arrows-alt"></i>
              </button>
            </div>
            <div class="mr-2">
              <div class="btn-group mr-1" dropdown>
                <button
                  class="dropdown-toggle btn btn-sm btn-primary"
                  dropdownToggle
                  type="button"
                >
                  {{ currentSite.name }}
                </button>
                <ul *dropdownMenu class="dropdown-menu">
                  <li
                    (click)="setSite(site)"
                    *ngFor="let site of sitesReferences"
                    class="btn btn-sm dropdown-item"
                  >
                    {{ site.name }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div
            class="d-flex h-100 w-100 flex-grow-1 ag-grid-container"
            *ngIf="mode === 'model'"
          >
            <app-grid
              [gridUid]="'models_clone_from_models'"
              (selectionChanged)="modelOnSelectionChanged($event)"
              [gridOptions]="modelsGridOptions"
              [rowData]="models"
              class="ag-theme-alpine"
              style="width: 100%; height: 100%"
            >
            </app-grid>
          </div>
        </div>
      </tab>
    </tabset>
  </div>
  <div class="modal-footer">
    <div class="form-group">
      <div class="col-12 d-flex justify-content-between">
        <button (click)="bsModalRef.hide()" class="btn btn-sm btn-light mr-2">
          <i class="la la-ban"></i>
          {{ "navigations.cancel" | translate }}
        </button>
        <button
          (click)="save()"
          [disabled]="
            (!form.pristine &&
              !form.dirty &&
              isSubmitted &&
              mode !== 'model') ||
            (!form.valid && mode !== 'model') ||
            (modelsSelectedNodes.length === 0 && mode === 'model')
          "
          class="btn btn-sm btn-success"
        >
          <i *ngIf="!isSubmitted" class="la la-save"></i>
          <i *ngIf="isSubmitted" class="la la-spinner la-spin"></i>
          {{ "navigations.save" | translate }}
        </button>
      </div>
    </div>
  </div>
</ng-container>
